import { render, staticRenderFns } from "./contract-bg.vue?vue&type=template&id=023ebcf0&scoped=true"
import script from "./contract-bg.vue?vue&type=script&lang=js"
export * from "./contract-bg.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=023ebcf0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ebcf0",
  null
  
)

export default component.exports